var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Secure Page")]),_c('h5',[_vm._v("Data from GET /secure-data:")]),_c('div',{staticClass:"results"},[_c('pre',[_vm._v(_vm._s(_vm.data))])]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }